<template>
  <div
    v-show="visible"
    class="c-player__error"
  >
    <div
      v-if="errorCode"
      class="c-player__error__message o-badge o-badge--error"
    >
      <i class="c-player__error__icon o-icon o-icon--caution o-badge__icon"></i>
      <div>
        <p>{{ $t(`player.errors.${errorCode}.header`) }}</p>
        <p>{{ $t(`player.errors.${errorCode}.message`) }}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import { ErrorCode } from '@/shared/enums';

  export default {
    data() {
      return {
        visible: false,
        code: undefined,
        icon: 'icon-sad-face',
      };
    },
    computed: {
      errorCode() {
        return this.code && this.code.toLowerCase().replace(/_(.)/g, (m, p) => p.toUpperCase());
      },
    },
    methods: {
      show(code) {
        this.visible = true;
        this.code = ErrorCode[code] || ErrorCode.GENERIC;
      },
      hide() {
        this.visible = false;
        this.code = undefined;
      },
    },
  };
</script>
